<template>
  <form>
    <vs-dialog overflow-hidden v-model="change">
      <div>
        <div class="modal-header">
          <v-card-title>Update profile</v-card-title>
          <!-- <h5 class="modal-title">Update profile</h5> -->
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span></span>
          </button>
        </div>
        <div class="modal-body">
          <v-card-text
            >To save changes insert your current password</v-card-text
          >
          <!-- <p>To save changes insert your current password</p> -->
          <div class="md-layout-item md-small-size-100 md-size-90">
            <v-text-field
              :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show1 ? 'text' : 'password'"
              label="Olde Password"
              v-model="old"
              :error-messages="opasswordErrors"
              @input="$v.old.$touch()"
              @blur="$v.old.$touch()"
              required
              class="input-group--focused"
              @click:append="show1 = !show1"
            ></v-text-field>
          </div>
        </div>
        <div>
          <v-row style="justify-content: flex-end; margin-right: 40px;">
            <button type="button" class="btn btn-success" @click="save()">
              Save changes
            </button>
          </v-row>
          <v-row></v-row>
        </div>
      </div>
    </vs-dialog>

    <md-card>
      <md-card-header style="background-color: #31a9e1">
        <h4 class="title">Edit Profile</h4>
        <p class="category">Complete your profile</p>
      </md-card-header>

      <md-card-content>
        <div class="md-layout">
          
          <!--     <div  class="md-layout-item md-size-100 md-large-size-100">
            <v-text-field
              v-model="name" autofocus
              label="name"
              type="name"
              @input="$v.email.$touch()"
              @blur="$v.email.$touch()"
              required
            ></v-text-field>
          </div> -->

          <div class="md-layout-item md-size-100 md-large-size-100">
            <v-text-field
              v-model="email"
              :error-messages="emailErrors"
              label="Email"
              type="email"
              @input="$v.email.$touch()"
              @blur="$v.email.$touch()"
              required
            ></v-text-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <v-text-field
              label="First Name"
              v-model="firstname"
              :error-messages="firstNErrors"
              required
              @input="$v.firstname.$touch()"
              @blur="$v.firstname.$touch()"
            />
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <v-text-field
              label="Last Name"
              v-model="lastname"
              :error-messages="lastNErrors"
              @input="$v.lastname.$touch()"
              @blur="$v.lastname.$touch()"
              required
            />
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <v-text-field
              :append-icon="show3 ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show3 ? 'text' : 'password'"
              label="Password"
              v-model="password"
              :error-messages="passwordErrors"
              @input="$v.password.$touch()"
              @blur="$v.password.$touch()"
              required
              class="input-group--focused"
              @click:append="show3 = !show3"
            ></v-text-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <v-text-field
              :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show2 ? 'text' : 'password'"
              label="Confirm Password"
              v-model="cpassword"
              :error-messages="cpasswordErrors"
              @input="$v.cpassword.$touch()"
              @blur="$v.cpassword.$touch()"
              required
              class="input-group--focused"
              @click:append="show2 = !show2"
            ></v-text-field>
          </div>

          <span class="text-danger">{{ err }}</span>
          <span class="text-success">{{ suc }}</span>
          <div class="md-layout-item md-size-100 text-right">
            <md-button class="md-raised md-success" @click="ft_update()"
              >Update Profile</md-button
            >
          </div>
        </div>
      </md-card-content>
    </md-card>
  </form>
</template>
<script>
import router from "@/routes";
import User from "@/services/Users";
import isEmpty from "@/outils/isEmpty";
import { validationMixin } from "vuelidate";
import {
  required,
  email,
  minLength,
  maxLength,
  sameAs,
} from "vuelidate/lib/validators";
export default {
  name: "edit-profile-form",
  mixins: [validationMixin],
  props: {
    dataBackgroundColor: {
      type: String,
      default: "",
    },
  },
  validations: {
    firstname: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(10),
    },
    lastname: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(10),
    },
    email: { required, email },
    password: {
      minLength: minLength(6),
    },
    cpassword: {
      sameAsPassword: sameAs("password"),
    },
    old: {
      required,
      minLength: minLength(6),
    },
    nodeId: {
      required,
      email,
    },
  },
  data() {
    return {
      change: false,
      dialog: false,
      old: "",
      email: "",
      lastname: "",
      firstname: "",
      password: "",
      cpassword: "",
      show3: false,
      show2: false,
      show1: false,
      err: "",
      suc: "",
      olddata: [],
    };
  },

  computed: {
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push("Must be valid e-mail");
      !this.$v.email.required && errors.push("E-mail is required");
      return errors;
    },

    firstNErrors() {
      const errors = [];
      if (!this.$v.firstname.$dirty) return errors;
      !this.$v.firstname.maxLength &&
        errors.push("firstname must be at most 10 characters long");
      !this.$v.firstname.required && errors.push("firstname is required.");
      return errors;
    },

    lastNErrors() {
      const errors = [];
      if (!this.$v.lastname.$dirty) return errors;
      !this.$v.lastname.maxLength &&
        errors.push("LastName must be at most 10 characters long");
      !this.$v.lastname.required && errors.push("LastName is required.");
      return errors;
    },

    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.minLength &&
        errors.push(
          `Password must have at least ${this.$v.password.$params.minLength.min} letters.`
        );
      // !this.$v.password.required && errors.push("Password is required.");
      return errors;
    },
    cpasswordErrors() {
      const errors = [];
      if (!this.$v.cpassword.$dirty) return errors;
      !this.$v.cpassword.sameAsPassword &&
        errors.push("Passwords must be identical.");
      // !this.$v.cpassword.required &&
      // errors.push("Confirm Password is required.");
      return errors;
    },
    opasswordErrors() {
      const errors = [];
      if (!this.$v.old.$dirty) return errors;
      !this.$v.old.minLength &&
        errors.push(
          `Password must have at least ${this.$v.password.$params.minLength.min} letters.`
        );
      !this.$v.old.required && errors.push("Password is required.");
      return errors;
    },
  },
  methods: {
    close() {
      this.change = false;
    },
    ft_update() {
      this.change = true;
    },
    save() {
      this.change = false;
      let data = {
        email: "",
        lastname: "",
        firstname: "",
        new: "",
        old: "",
      };
      data.email = this.email;
      data.lastname = this.lastname;
      data.firstname = this.firstname;
      data.new = this.password;
      data.old = this.old;
      User.Updatedetails(data, this.olddata)
        .then((r) => {
          this.suc = "Profile Updated";
          this.err = "";
          setTimeout(function() {
            this.suc = "";
          }, 1500);
        })
        .catch((er) => {
          this.err = er;
          this.suc = "";
          setTimeout(function() {
            this.err = "";
          }, 1500);
        });
    },
  },
  created() {
    /* if(this.$store.state.Auth == false)
        router.push('/login')*/
    let a = localStorage.getItem("authToken");
    User.GetUser(a)
      .then((res) => {
        this.olddata = res;
        this.email = res.data.Email;
        this.lastname = res.data.lastname;
        this.firstname = res.data.firstname;
      })
      .catch((er) => console.log(er));
  },
};
</script>
<style></style>
